import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Mobile from "../../component/mobile/mobile";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import "./Homeattendee.css";
import { Link } from "react-router-dom";
import { FaHeart, FaAngleRight, FaAngleDown } from "react-icons/fa6";
import nurseservice2 from "../../assets/banner1.jpg";
import nurseservice3 from "../../assets/banner2.jpg";
import nurseservice4 from "../../assets/banner.png";
import nursevideo from "../../assets/servicevideo.png";
import icon from "../../assets/Hygiene&grooming1.png";
import icon1 from "../../assets/p6.png";
import icon2 from "../../assets/exercise.svg.png";
import icon3 from "../../assets/emergencyDrug.png";
import icon4 from "../../assets/medication.png";
import icon5 from "../../assets/emotionSupport.png";
import icon6 from "../../assets/sugerCheck.png";
import icon7 from "../../assets/patients.png";
import icon8 from "../../assets/wheelchair.png";
import rate from "../../assets/customer-Rateing.png";
import rate1 from "../../assets/customer-satisfaction.png";
import rate2 from "../../assets/exprience.png";
import rate3 from "../../assets/nurse-service.png";
import rate4 from "../../assets/doctor.png";
import rate5 from "../../assets/nurse-check.png";
import rate6 from "../../assets/nurse.png";
import productimage from "../../assets/location-marker.png";
import productimage1 from "../../assets/mdi_education-outline.png";
import productimage2 from "../../assets/SVG.png";

// Import images for products
import product1 from "../../assets/nursingservice1.png";
import product2 from "../../assets/nursingservice2.png";
import product3 from "../../assets/nursingservice3.png";

import staff1 from "../../assets/doctor1.png";
import staff2 from "../../assets/doctor2.png";
import staff3 from "../../assets/doctor3.png";
import staff4 from "../../assets/doctor4.png";
import { Timeperiod, EmployeeDetails, Vendorlist } from "../../env/action";
import { UserContext } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
function Homeattendee() {
  const { subservice_id, setTimeperiodid, timeperiod_id } = useContext(UserContext);
  const { subserviceid } = useParams();
  const [wishlist, setWishlist] = useState(false);
  const [activePlan, setActivePlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [timeperiods, setTimeperiods] = useState([]);
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [vendorlist, setVendor] = useState([]);
  const subServiceName = localStorage.getItem("selectedSubserviceName");

  const navigate = useNavigate();
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Show loader

      const params = { subservice_id: subserviceid };
      console.log(params, "Fetching time period...");

      Timeperiod(params, (res) => {
        if (res.status === 1) {
          console.log(res.data, "Received data");
          setTimeperiods(res.data);
        } else {
          console.log("No time period found");
        }
        setLoading(false);
      });
    };

    fetchData();
  }, [subservice_id]);

  const getTimeperiodId = (id) => {
    setTimeperiodid(id);
    navigate(`/nursingservice/subservicevariant/${id}`);
  };

  // Product Slider Settings
  const productSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3, // Show multiple slides
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false, // Keep arrows for product slider
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  const staffSliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  // Product Data

  useEffect(() => {
    EmployeeDetails(((res) => {
      if (res.status === 1) {
        setEmployeeDetails(res.data);

      } else {
        console.log('No employee details found');
      }
    }))
  }, [])

  useEffect(() => {
    Vendorlist((res) => {
      if (res.status === 1) {
        setVendor(res.data);
        console.log(res.data, "-------dataa");
      } else {
        console.log("No vendor found");
      }
    });
  }, []);

  return (
    <>
      <Slider {...settings} className="xyz">
        <div>
          <img src={nurseservice2} style={{ width: "100%", height: "auto" }} />
        </div>
        <div>
          <img
            src={nurseservice3}
            alt="Banner 2"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
        <div>
          <img
            src={nurseservice4}
            alt="Banner 3"
            style={{ width: "100%", height: "auto" }}
          />
        </div>
      </Slider>

      <div className="nursingSubcategory1">
        <p className="text-center fw-bolder text-1">
          Compassionate Nursing Services ({subServiceName}) Provided at Home by a Licensed
          Professional
        </p>
      </div>

      {/* New Section for Services & Form */}
      <div className="home-attendant-container">
        <div className="services-section">
          <div className="services-grid">
            <div className="service-item">
              <img
                src={icon}
                alt="Infection Control"
                className="service-icon"
              />
              <span>Infection control & wound dressing</span>
            </div>
            <div className="service-item">
              <img
                src={icon1}
                alt="Infection Control"
                className="service-icon"
              />
              <span>Care of tubes & catheters</span>
            </div>
            <div className="service-item">
              <img
                src={icon2}
                alt="Infection Control"
                className="service-icon"
              />
              <span> Range of motion exercises</span>
            </div>
            <div className="service-item">
              <img
                src={icon3}
                alt="Infection Control"
                className="service-icon"
              />
              <span>Emergency drugs</span>
            </div>
            <div className="service-item">
              <img
                src={icon4}
                alt="Infection Control"
                className="service-icon"
              />
              <span>High alert medication </span>
            </div>
            <div className="service-item">
              <img
                src={icon5}
                alt="Infection Control"
                className="service-icon"
              />
              <span>Companionship & emotional support</span>
            </div>
            <div className="service-item">
              <img
                src={icon6}
                alt="Infection Control"
                className="service-icon"
              />
              <span>Temperature/BP/Sugar check </span>
            </div>
            <div className="service-item">
              <img
                src={icon7}
                alt="Infection Control"
                className="service-icon"
              />
              <span>Repositioning bedridden patients</span>
            </div>
            <div className="service-item">
              <img
                src={icon8}
                alt="Infection Control"
                className="service-icon"
              />
              <span>Wheelchair support & fall prevention</span>
            </div>
          </div>

          <h2>
            Looking for the best male / female nurse for home care? Our nurses
            provide complete health support.
          </h2>
          <p>
            Our skilled nurses & caregivers follow clinical protocols as per
            international standards while delivering the best home nurse
            service.
          </p>
        </div>

        {/* <div className="form-section">
          <h3>Book Attendant Services at Home With TTHC</h3>
          <form>
            <input type="text" placeholder="Patient Name*" required />
            <input type="tel" placeholder="Mobile Number*" required />
            <input type="email" placeholder="Email Id" />
            <input type="text" placeholder="Address" />
            <input type="text" placeholder="Service Required" />
            <button type="submit" className="book-btn">
              Book an Appointment
            </button>
          </form>
          <p className="disclaimer">
            By submitting the form, you Agree to TTHC
          </p>
        </div> */}
      </div>

      <div className="packagesec">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="packg">
                <h2>Choose your caregiver plan</h2>
              </div>
            </div>

            {loading ? (
              <p>Loading plans...</p>
            ) : timeperiods.length > 0 ? (
              timeperiods.map((plan) => (
                <div
                  className="col-lg-4 col-md-6 mb-4"
                  key={plan.time_period_id}
                >
                  <div
                    className={`packag ${activePlan === plan.time_period_id ? "active" : ""
                      }`}
                    onClick={() => {
                      setActivePlan(plan.time_period_id);
                      getTimeperiodId(plan.time_period_id);
                    }}
                  >
                    <h6
                      className={
                        activePlan === plan.time_period_id ? "active-text" : ""
                      }
                    >
                      {plan.time_period} Hours
                      <FaAngleRight className="ml-3 arrow-icon" />
                    </h6>
                    <p>{plan.description}</p>
                  </div>
                </div>
              ))
            ) : (
              <p>No plans found</p>
            )}
          </div>
        </div>
      </div>

      <div className="home-attendant-container">
        <div className="services-section1">
          <h2>Why choose TTHC for {subServiceName} services?</h2>
          <p>
            Due to changes in the family structure—from the multi-generation
            family under one roof to the nuclear family—many of us are facing
            challenges in caring for our elderly parents. This challenge
            increases if the children live in one part of the world and the
            parents in another. Distance can make it difficult to assess a
            parent’s needs and get them the care they deserve. Tech Tricks
            Health Care Service is committed to helping you care for the health
            and well-being of your loved ones. We understand that nothing is
            better than being in the comfort of home, surrounded by family and
            friends. We can be there when you can't to help your aging parents
            and other elderly family members live their golden years at home. We
            provide health care services at your home. It has a team of
            well-trained nurses and more supportive staff to take care of
            elderly, sick, bedridden patients.
          </p>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-3 col-md-6 col-4 mb-4">
            <div className="rating">
              <div className="ratingimg">
                <img src={rate} alt="Nursing Video" className="rate-image" />
              </div>
              <p>Highest Customer Rating</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-4 mb-4">
            <div className="rating">
              <div className="ratingimg">
                <img src={rate1} alt="Nursing Video" className="rate-image" />
              </div>
              <p>First Priority Customer Satisfaction</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-4 mb-4">
            <div className="rating">
              <div className="ratingimg">
                <img src={rate2} alt="Nursing Video" className="rate-image" />
              </div>
              <p>Experienced Certified Staff</p>
            </div>
          </div>
        </div>
      </div>

      <div className="nursing-steps-container">
        <div className="nursing-steps">
          <p className="steps-heading">
            Your credible home nursing services are just a call away.
          </p>
          <Accordion>
            <AccordionItem
              header={
                <div className="accordion-header prel">
                  <span className="accordion-number">1</span>
                  <span>Contact Us</span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </AccordionItem>
            <div className="accordion-divider"></div> {/* Underline */}
            <AccordionItem
              header={
                <div className="accordion-header prel">
                  <span className="accordion-number">2</span>
                  <span>Choose Attends</span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              Quisque eget luctus mi, vehicula mollis lorem. Proin fringilla vel
              erat quis sodales.
            </AccordionItem>
            <div className="accordion-divider"></div> {/* Underline */}
            <AccordionItem
              header={
                <div className="accordion-header prel">
                  <span className="accordion-number">3</span>
                  <span>Pay for the Service</span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              Suspendisse massa risus, pretium id interdum in, dictum sit amet
              ante.
            </AccordionItem>
          </Accordion>
        </div>

        <div className="nursing-video">
          <img
            src={nursevideo}
            alt="Nursing Video"
            className="video-thumbnail"
          />
          <button className="watch-now-btn">WATCH NOW</button>
        </div>
      </div>

      <div className="home-attendant-container1">
        <div className="services-section1">
          <h2>What to Expect</h2>
        </div>
      </div>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className="rating">
              <div className="ratingimg">
                <img src={rate3} alt="Nursing Video" className="rate-image" />
              </div>
              <p>12/24 hour Nursing Services</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className="rating">
              <div className="ratingimg">
                <img src={rate4} alt="Nursing Video" className="rate-image" />
              </div>
              <p>Free Doctor Consultation</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className="rating">
              <div className="ratingimg">
                <img src={rate5} alt="Nursing Video" className="rate-image" />
              </div>
              <p>Background check for all Nurse</p>
            </div>
          </div>
          <div className="col-lg-3 col-md-6 col-6 mb-4">
            <div className="rating">
              <div className="ratingimg">
                <img src={rate6} alt="Nursing Video" className="rate-image" />
              </div>
              <p>Trained Nurse</p>
            </div>
          </div>
        </div>
      </div>

      <div className="home-attendant-container1">
        <div className="services-section1">
          <h2>Because there is no place like home</h2>
          <p>
            We intend to be the most trusted home healthcare partner to our
            clients and deliver people-centric, high quality patient care to
            them in the comfort of their homes.
          </p>
          <ul>
            <li>Bedridden Care</li>
            <li>Help for daily Activities of a senior citizen</li>
            <li>Care for loved one recovering from Surgery. </li>
            <li>Tracheostomy Care at Home. </li>
            <li>Care for patients recovering Stroke.</li>
          </ul>
        </div>
      </div>

      <div className="home-attendant-container1">
        <div className="services-section1">
          <h2>Meet Our Service Provider</h2>
        </div>
      </div>

      {/* Product Slider Section */}
      <div className="product-slider-container">
        <Slider {...productSettings}>
          {vendorlist.map((vendor) => (
            <div key={vendor.id} className="product-card">
              <div className="pro">
                <img
                  src={vendor.vendor_logo}
                  alt={vendor.company_name}
                  className="product-image"
                />
              </div>

              <h3>{vendor.company_name}</h3>
              <p>
                <span>
                  <img src={productimage} className="product-icon" />
                </span>
                {vendor.address}
              </p>
              {/* <button className="view-button">View</button> */}
            </div>
          ))}
        </Slider>
      </div>

      <div className="home-attendant-container1">
        <div className="services-section1">
          <h2>Meet Our Medical Attendant Staff</h2>
        </div>
      </div>
      <div className="staff-slider-section">
        <Slider {...staffSliderSettings}>
          {employeeDetails.map((staff) => {
            const address = staff.employee_address?.[0] || {}; // safely get first address or empty object
            return (
              <div key={staff.id} className="staff-card">
                <div className="image-container">
                  <img
                    src={staff.employee_profileimage}
                    alt={staff.employee_name}
                    className="staff-image"
                  />
                  {/* <button
                    className="wishlist-btn"
                    onClick={() => setWishlist(!wishlist)}
                  >
                    {wishlist ? (
                      <FaHeart color="red" />
                    ) : (
                      <FaHeart color="gray" />
                    )}
                  </button> */}
                </div>
                <h4>{staff.employee_name}</h4>
                <p className="staff-specialty">
                  {staff.department} • {staff.experience_or_fresher}
                </p>
                <p>
                  <span>
                    <img src={productimage1} className="product-icon" />
                  </span>
                  {staff.designation}
                </p>

                <p>
                  <span>
                    <img src={productimage} className="product-icon" />
                  </span>
                  {[address.at, address.post, address.district]
                    .filter(Boolean)
                    .join(', ')}
                </p>
                {/* <div className="staff-buttons">
                  <button className="view-button">View</button>
                  <button className="book-button">Book Appointment</button>
                </div> */}
              </div>
            );
          })}
        </Slider>
      </div>

      {/* <div className='packagesec'>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4 col-md-6 mb-4">
                            <div className="packg">
                                <h2>Choose your caregiver plan</h2>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4" >
                            <Link to="/nursingservice/homeattendee/care" className="hor text-decoration-none">
                                <div className={`packag ${activePlan === '24h' ? 'active' : ''}`}
                                    onClick={() => setActivePlan('24h')}>
                                    <h6 className={activePlan === '24h' ? 'active-text' : ''}>24 Hours
                                        <FaAngleRight className="ml-3 arrow-icon" />
                                    </h6>
                                    <p>Choose between 1 provider or 2
                                        providers who will stay with you to
                                        provide care through out the day and
                                        night.</p>

                                </div>
                            </Link>
                        </div>

                        <div className="col-lg-4 col-md-6 mb-4">
                            <Link to="/nursingservice/homeattendee/care" className="hor text-decoration-none">
                                <div className={`packag ${activePlan === '12h' ? 'active' : ''}`}
                                    onClick={() => setActivePlan('12h')}>
                                    <h6 className={activePlan === '12h' ? 'active-text' : ''}>12 Hours
                                        <FaAngleRight className="ml-3 arrow-icon" />
                                    </h6>
                                    <p>Choose between your required shift for the duration of 12 hours, day or night, For example, 8PM-BAM or 8AM -
                                        8PM.</p>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div> */}

      <div className="home-attendant-container2">
        <div className="services-section2">
          <h2>TTHC {subServiceName} services</h2>
          <p>
            Our service providers are spread across different locations, work at
            different intervals, and speak multiple languages. We are always
            closer to you. Enjoy the comfort and access to a spectrum of medical
            services right from your home. A trustworthy source of personalized
            health care services that can be accessed from anywhere in the hour
            of need.
          </p>
        </div>
      </div>
      <div className="home-attendant-container2">
        <div className="services-section2">
          <h2>Our expert {subServiceName}</h2>
          <p>
            Our attendants for senior citizens or nursing attendants at home are
            a highly skilled caregiver, well-trained to meet the specific needs
            of our clients. We place a strong emphasis on caregiver selection
            and training, ensuring that all professionals are well-prepared to
            provide top-notch care. Our unwavering commitment to delivering
            excellence in patient or senior care is evident in how we
            proactively address any skill gaps through extensive on-the-job
            training for our team members.
          </p>
        </div>
      </div>
      <div className="home-attendant-container2">
        <div className="services-section2">
          <h2>What to expect from tech tricks healthcare services at home?</h2>
          <p>
            Home Health care Nursing starts only after the recommendation of a
            doctor, and it is important for the patient to see a home nurse as
            often as a doctor. The nursing services as mentioned before are
            provided by registered nurses who help in ongoing medical support
            and rehabilitative care.
          </p>
        </div>
      </div>

      <div className="additional-accordion-section home-attendant-container1">
        <div className="services-section1">
          <h2>Frequently Asked Questions</h2>
          <Accordion className="accordion-faq">
            <AccordionItem
              header={
                <div className="faq-accordion-header prel">
                  <span className="faqhead">
                    What is the cost of {subServiceName}?
                  </span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              The responsibilities of a patient attendant (at home) usually
              involve delivering care and support services that are personalized
              to unique requirements, and who can easily integrate with your
              loved ones. Our skilled {subServiceName} are here to assist with
              all aspects of daily living, including bathing, dressing,
              grooming, and medication management. Patient attendants (including
              a female or male attendant for elderly) may also assist with
              patient mobility, turning and repositioning, monitoring vital
              signs, providing companionship, and reporting any changes in the
              patient's condition to the healthcare team. Their responsibilities
              may also include maintaining a clean and safe environment for the
              patient, providing emotional support, and following care plans as
              directed by healthcare professionals.
            </AccordionItem>
            <div className="faq-divider"></div>

            <AccordionItem
              header={
                <div className="faq-accordion-header prel">
                  <span className="faqhead">
                    When do you need in home patient attendants do?
                  </span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              The responsibilities of a patient attendant (at home) usually
              involve delivering care and support services that are personalized
              to unique requirements, and who can easily integrate with your
              loved ones. Our skilled {subServiceName} are here to assist with
              all aspects of daily living, including bathing, dressing,
              grooming, and medication management. Patient attendants (including
              a female or male attendant for elderly) may also assist with
              patient mobility, turning and repositioning, monitoring vital
              signs, providing companionship, and reporting any changes in the
              patient's condition to the healthcare team. Their responsibilities
              may also include maintaining a clean and safe environment for the
              patient, providing emotional support, and following care plans as
              directed by healthcare professionals.
            </AccordionItem>
            <div className="faq-divider"></div>

            <AccordionItem
              header={
                <div className="faq-accordion-header prel">
                  <span className="faqhead">
                    How do you maintain the quality of your {subServiceName}
                    services?
                  </span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              The responsibilities of a patient attendant (at home) usually
              involve delivering care and support services that are personalized
              to unique requirements, and who can easily integrate with your
              loved ones. Our skilled {subServiceName} are here to assist with
              all aspects of daily living, including bathing, dressing,
              grooming, and medication management. Patient attendants (including
              a female or male attendant for elderly) may also assist with
              patient mobility, turning and repositioning, monitoring vital
              signs, providing companionship, and reporting any changes in the
              patient's condition to the healthcare team. Their responsibilities
              may also include maintaining a clean and safe environment for the
              patient, providing emotional support, and following care plans as
              directed by healthcare professionals.
            </AccordionItem>
            <div className="faq-divider"></div>
            <AccordionItem
              header={
                <div className="faq-accordion-header prel">
                  <span className="faqhead">
                    Are your attendants available for 24hous care?
                  </span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              The responsibilities of a patient attendant (at home) usually
              involve delivering care and support services that are personalized
              to unique requirements, and who can easily integrate with your
              loved ones. Our skilled {subServiceName} are here to assist with
              all aspects of daily living, including bathing, dressing,
              grooming, and medication management. Patient attendants (including
              a female or male attendant for elderly) may also assist with
              patient mobility, turning and repositioning, monitoring vital
              signs, providing companionship, and reporting any changes in the
              patient's condition to the healthcare team. Their responsibilities
              may also include maintaining a clean and safe environment for the
              patient, providing emotional support, and following care plans as
              directed by healthcare professionals.
            </AccordionItem>
            <div className="faq-divider"></div>
            <AccordionItem
              header={
                <div className="faq-accordion-header prel">
                  <span className="faqhead">
                    Can my attendants be replaced?
                  </span>
                  <FaAngleDown className="ml-3 arrow-icon pab" />
                </div>
              }
            >
              The responsibilities of a patient attendant (at home) usually
              involve delivering care and support services that are personalized
              to unique requirements, and who can easily integrate with your
              loved ones. Our skilled {subServiceName} are here to assist with
              all aspects of daily living, including bathing, dressing,
              grooming, and medication management. Patient attendants (including
              a female or male attendant for elderly) may also assist with
              patient mobility, turning and repositioning, monitoring vital
              signs, providing companionship, and reporting any changes in the
              patient's condition to the healthcare team. Their responsibilities
              may also include maintaining a clean and safe environment for the
              patient, providing emotional support, and following care plans as
              directed by healthcare professionals.
            </AccordionItem>
          </Accordion>
        </div>
      </div>

      <Mobile />
    </>
  );
}

export default Homeattendee;
